<template>
	<div class="w-100 p-4">
		<div v-if="isWaiting" class="alert alert-light">
			لطفا کمی صبر کنید ...
		</div>
		<div v-else-if="isShowTimeError" class="alert alert-danger">
			به علت تنظیم نبودن ساعت دستگاه شما امکان ادامه عملیات وجود ندارد. لطفا ساعت دستگاه خود را تنظیم نمایید و عملیات ورود را مجدد تکرار فرمایید.
		</div>
		<div v-else-if="isShowStorageError" class="alert alert-danger">
			خطا در عملیات ورود ، لطفا عملیات ورود را مجدد تکرار فرمایید.
		</div>
		<div v-else-if="isShowUnknownError" class="alert alert-danger">
			خطا در عملیات ورود ، لطفا با پشتیبانی تماس حاصل فرمایید.
		</div>
	</div>
</template>

<script>
	import store from "@/store";
	import Oidc from "oidc-client";
	import utility from "@/plugins/utility";

	const db = new utility.db();

	export default {
		name: "SigninOidc",

		data()
		{
			return {
				isShowTimeError: false,
				isShowStorageError: false,
				isShowUnknownError: false,
				isWaiting : true
			}
		},

		mounted()
		{
			var mgr = new Oidc.UserManager({
				loadUserInfo: true,
				response_mode: "query",
				filterProtocolClaims: true,
				userStore: new Oidc.WebStorageStateStore()
			});

			mgr.signinRedirectCallback()
				.then(user =>
				{
					axios({
						method: "post",
						url: "/create-token",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded",
							Authorization: "Bearer " + user.access_token
						},
						data: "username=exchange&password=exchange&grant_type=password"
					}).then(response =>
					{
						if (response.data == "User not found")
						{
							this.$router.push("/auth?t=signup");
						} else
						{
							store.token = response.data;
							db.insert("__t", response.data);

							axios.defaults.headers.common["Authorization"] =
								"Bearer " + store.token.access_token;

							this.gotoClub();
							return;
						}
					}).catch(error =>
					{
						if (error.response.status == 400)
						{
							this.$router.push("/auth?t=signup");
						}
					});
				})
				.catch(error =>
				{
					this.isWaiting = false;

					if ((error.message || "").indexOf("iat is in the future") > -1)
					{
						this.isShowTimeError = true;
					}

					else if ((error.message || "").indexOf("No matching state found in storage") > -1)
					{
						this.isShowStorageError = true;
					}

					else if ((error.message || "").indexOf("login_required") > -1)
					{
						localStorage.clear()
						this.isShowUnknownError = true;
					}

					else
					{
						this.isShowUnknownError = true;
					}

					console.log(error)
				});
		},

		methods: {
			gotoClub()
			{
				this.request(
					"/api/App/GetCustomerInfo",
					null,
					response =>
					{
						if (response)
						{
							store.customer = response.meta.Customer;
							db.insert("__c", response.meta.Customer);
							const redirectPath = "/club/dashboard";
							this.$router.push(redirectPath);
						} else
						{
							this.errors = [{ type: "errors.server" }];
						}
					},
					"get"
				);
			},

			request(url, data, succees, method)
			{
				this.loading = true;
				axios({
					method: method || "post",
					url: url,
					data: data
				})
					.then(response =>
					{
						this.loading = false;
						succees(response.data);
					})
					.catch(error =>
					{
						this.errors = [{ type: "errors.server" }];
						this.loading = false;
					});
			}
		}
	};
</script>
